var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1Tramway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v4h-3.72a3 3 0 01-5.89.62l-.07-.45V61H64a2.59 2.59 0 01-.1.62 3 3 0 01-5.78 0l-.12-.45V61H18.15c-.01.21-.04.417-.09.62a3 3 0 01-5.79 0l-.08-.45a1.122 1.122 0 000-.17h-1.11a3 3 0 01-5.89.62l-.07-.45V61H1v-4h74zm0-3.12H1v-6.63L12 32h26.14l-11.23-7 11.23-7H1v-4h74v4H39.32l10.45 7-10.45 7H65l10 15.25v6.63zM16 36h-2l-5.83 9H16v-9zm10 0h-6v14h6V36zm12.68-8.38l3.9-2.62-3.9-2.62L34.47 25l4.21 2.62zM46 36H30v9h16v-9zm10 0h-6v14h6V36zm11.25 8l-5.17-8H60v8h7.25z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Tramway.a55b3984.svg";
export { SvgI1Tramway as ReactComponent };